import { idtype } from "querypieces";

export default `
  ...on pageBuilder_code_BlockType {
    ${idtype}
    plainText
  }
`
